/*
 * Sleepee — system światów Baby / Pets
 * Stan świata żyje w: <html data-world="baby|pets|none"> + cookie sleepee_world + localStorage.
 * Ustawiany jest już w <head> przez snippet sleepee-world-init (zero migotania).
 * Ten plik dokłada API, obsługę klików i zdarzenie 'sleepee:worldchange'.
 */
(function () {
  'use strict';

  var WORLDS = ['baby', 'pets'];
  var COOKIE = 'sleepee_world';
  var ATTR = 'data-world';

  function valid(w) { return WORLDS.indexOf(w) > -1 ? w : null; }

  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : null;
  }

  function writeCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';path=/;max-age=31536000;samesite=lax';
  }

  var SleepeeWorld = {
    WORLDS: WORLDS.slice(),

    /** Aktualny świat lub null, jeśli użytkownik jeszcze nie wybrał (gateway). */
    get: function () {
      return valid(document.documentElement.getAttribute(ATTR)) || valid(readCookie(COOKIE));
    },

    /** Czy świat jest wymuszony przez kontekst strony (produkt/kolekcja z danego świata). */
    isForced: function () {
      return !!(window.SleepeeWorldBoot && window.SleepeeWorldBoot.forced);
    },

    /**
     * Ustawia świat.
     * @param {string} world 'baby' | 'pets'
     * @param {Object} [opts] { redirect: string|null, silent: boolean }
     */
    set: function (world, opts) {
      world = valid(world);
      if (!world) return false;

      opts = opts || {};
      var previous = this.get();

      writeCookie(COOKIE, world);
      try { window.localStorage.setItem(COOKIE, world); } catch (e) {}
      syncControls(world);

      // Przy przejściu na inną stronę NIE przełączamy data-world na bieżącej: CSS chował
      // wtedy od razu wszystkie bloki starego świata (hero, kafelki), a zostawały nagłówki
      // sekcji — przez czas ładowania nowej strony migał pusty, rozsypany układ.
      // Kotwica na tej samej stronie (#...) to nie jest przejście, więc przełączamy normalnie.
      if (opts.redirect && opts.redirect.charAt(0) !== '#') {
        window.location.href = opts.redirect;
        return true;
      }

      document.documentElement.setAttribute(ATTR, world);

      if (!opts.silent) {
        document.dispatchEvent(new CustomEvent('sleepee:worldchange', {
          detail: { world: world, previous: previous },
          bubbles: true
        }));
      }

      if (opts.redirect) window.location.href = opts.redirect;
      return true;
    },

    /** Czyści wybór — użytkownik wraca na gateway. */
    clear: function () {
      document.documentElement.setAttribute(ATTR, 'none');
      writeCookie(COOKIE, '');
      document.cookie = COOKIE + '=;path=/;max-age=0';
      try { window.localStorage.removeItem(COOKIE); } catch (e) {}
      syncControls(null);
    }
  };

  function syncControls(world) {
    var buttons = document.querySelectorAll('[' + 'data-world-set' + ']');
    for (var i = 0; i < buttons.length; i++) {
      var isActive = buttons[i].getAttribute('data-world-set') === world;
      buttons[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      buttons[i].classList.toggle('is-active', isActive);
    }
  }

  function onClick(event) {
    var trigger = event.target.closest ? event.target.closest('[data-world-set]') : null;
    if (!trigger) return;

    var world = trigger.getAttribute('data-world-set');
    if (!valid(world)) return;

    event.preventDefault();

    // Świat już aktywny na tej stronie — nic nie robimy (bez przeładowania).
    if (world === document.documentElement.getAttribute(ATTR) && trigger.classList.contains('is-active')) return;

    // data-world-url: dokąd polecieć po wyborze (np. kolekcja główna danego świata).
    // Brak atrybutu = zostajemy na miejscu i tylko przełączamy nawigację.
    var url = trigger.getAttribute('data-world-url');
    SleepeeWorld.set(world, { redirect: url || null });
  }

  function init() {
    syncControls(SleepeeWorld.get());
    document.addEventListener('click', onClick);

    // Theme editor: sekcje przeładowują się bez reloadu strony.
    document.addEventListener('shopify:section:load', function () {
      syncControls(SleepeeWorld.get());
    });
  }

  window.SleepeeWorld = SleepeeWorld;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
